import { render, staticRenderFns } from "./wxScanUpload.vue?vue&type=template&id=d3c514fa&scoped=true"
import script from "./wxScanUpload.vue?vue&type=script&lang=js"
export * from "./wxScanUpload.vue?vue&type=script&lang=js"
import style0 from "./wxScanUpload.vue?vue&type=style&index=0&id=d3c514fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3c514fa",
  null
  
)

export default component.exports